<template>
    <ak-stacked-window
        :showClose="false"
        :width="width"
        :minWidth="minWidth"
        :resizable="true"
        @resize="updateWidth"
        @close="close"
    >
        <div class="ak-form">
            <ak-loader  class="ak-form__loader" :loading="loading" />
            <div class="ak-form__header" v-if="! loading">
                <h1 class="ak-form__title">{{ $t('Statistieken voor') }} <b> {{ title }}</b></h1>
            </div>

            <div class="ak-form__fields" v-if="! loading"><div class="p-t-xs-20 p-b-xs-20">
                <p><b>{{ $t('Algemene statistieken') }}</b></p>
                <div class="ak-stats">
                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Kliks') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.clicks | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Unieke kliks') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.clicks_unique | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Impressies') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.impressions | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Unieke impressies') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.impressions_unique | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Weergaves') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.views | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('Unieke weergaves') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.views_unique | number }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('CTR impressies') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.ctr | number({precision: 2}) }}
                        </div>
                    </div>

                    <div class="ak-stat">
                        <div class="ak-stat__label">
                            {{ $t('CTR weergaves') }}
                        </div>
                        <div class="ak-stat__value">
                            {{ stats.ctr_views | number({precision: 2}) }}
                        </div>
                    </div>
                </div>
            </div>
                <div class="p-t-xs-20">
                    <p><b>Statistieken per afbeelding:</b></p>
                    <div class="ak-data-list__items"
                         style="
                        --data-list-item-width: 200px;
                        --card-top-padding: 0;
                        --card-bottom-padding: 15px;
                        gap: 15px;
                    "
                    >
                        <ak-card
                                v-for="mediaStats in statsByMedia"
                                :key="mediaStats.id"
                                :title="mediaStats.filename"
                                :img="mediaStats.url"
                        >
                            <template v-slot:bottom>
                                <p v-if="mediaStats.deleted"><span class="muted">({{$t('Verwijderd')}})</span></p>
                                <div class="ak-stats ak-stats--compact p-b-xs-20">
                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Kliks') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.clicks | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Unieke kliks') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.clicks_unique | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Impressies') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.impressions | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Unieke Impressies') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.impressions_unique | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Weergaves') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.views | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('Unieke Weergaves') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.views_unique | number }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('CTR impressies') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.ctr | number({precision: 2}) }}
                                        </div>
                                    </div>

                                    <div class="ak-stat ak-stat--compact">
                                        <div class="ak-stat__label">
                                            {{ $t('CTR weergaves') }}
                                        </div>
                                        <div class="ak-stat__value ak-stat__value--compact">
                                            {{ mediaStats.stats.ctr_views | number({precision: 2}) }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </ak-card>
                    </div>
                </div>
            </div>

            <div class="ak-form__footer">
                <div class="ak-button-group justify-content-end">
                    <ak-button :disableBackground="true" @click="close">
                        {{ $t('Sluiten') }}
                    </ak-button>
                </div>
            </div>
        </div>
    </ak-stacked-window>
</template>

<script>
import ResizableForm from './../../../../../vendor/multimedium/spine/resources/spine-cms-vue/src/components/mixins/ResizableForm';

export default {
    name: 'AdStats',
    mixins: [ResizableForm],
    data() {
        return {
            loading: false,
            title: null,
            stats: [],
            statsByMedia: [],
        }
    },
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            return this.$route.params.objectId;
        }
    },
    methods: {
        /**
         * Close
         */
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        },
        /**
         * Fetch data
         * @return {Promise<void>}
         */
        async fetchData() {
            this.loading = true;
            const data = await this.$get(this.$getSetting('paths.baseCms') +  '/ad/stats/' + this.objectId);
            this.loading = false;

            this.title = data.title;
            this.stats = data.stats.all;
            this.statsByMedia = data.stats.by_media;
        }
    },
    created() {
        this.fetchData();
    }
}
</script>
